import { Effect, Reducer, Subscription } from 'umi';
import {
  MONETIZATION_PAYMENT_REVENUE,
  MONETIZATION_MTX_REVENUE,
} from './_config/filterDvaKey';

export const namespace = 'monetization';

const MonetizationModel = {
  namespace: namespace,
  state: {
    data: {}
  },

  effects: {
    *getMonetizationRevenue({ payload }, { put }) {
      try {
        yield put({ type: "saveMonetizationRevenue", payload: { [MONETIZATION_PAYMENT_REVENUE]: payload } });
      } catch (e) {
        yield put({
          type: "saveMonetizationRevenue", payload: {

          }
        });
      }
    },
    *getMtxRevenue({ payload }, { put }) {
      try {
        yield put({ type: "saveMtxRevenue", payload: { [MONETIZATION_MTX_REVENUE]: payload } });
      } catch (e) {
        yield put({
          type: "saveMtxRevenue", payload: {

          }
        });
      }
    },
  },
  reducers: {
    saveMonetizationRevenue(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveMtxRevenue(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
  }
};

export default MonetizationModel;
